export default __webpack_public_path__ + "static/media/logo_azagros.1cd24c52.png";